import { QueryClient } from '@tanstack/react-query'
import { ApiError } from './api'

/**
 * TanStack Query owns ALL server state.
 *
 * The cart does not live here — it is ephemeral client state in cartStore.
 * Putting it in a query cache would make it refetchable, and a cart that can
 * be refetched is a cart that can silently lose a line mid-sale.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,

      // A POS refetching every time the cashier alt-tabs to check something
      // is maddening, and on a slow shop connection it is worse than that.
      refetchOnWindowFocus: false,

      retry: (failureCount, error) => {
        // Retrying a 401/403/404/422 just delays showing the user the real
        // answer. Only transient failures are worth a second attempt.
        if (error instanceof ApiError && error.status >= 400 && error.status < 500) {
          return false
        }
        return failureCount < 2
      },
    },
    mutations: {
      // Never automatically. A retried POST /sales without an idempotency key
      // would be a second sale.
      retry: false,
    },
  },
})
